import { CardSize } from '~components/card';
import { BodySize } from './constants';
import { capitalize } from '../../capitalize';

export function getSizeModifier(size: BodySize | CardSize): string {
	return `size${capitalize(size)}`;
}
